import React from "react";

// Line / label / line between the true matches and the "More suggestions"
// below them, so the two are never read as one list. Styles are
// .mls-suggestions__divider in styles/desktop/mls-listings.scss (global),
// the same markup WantadDetails renders for its suggestions.
const SuggestionsDivider = ({ label = "More suggestions" }) => (
  <div
    className="mls-suggestions__divider"
    role="separator"
    aria-label={label}
  >
    <span className="line" />
    <span className="label">{label}</span>
    <span className="line" />
  </div>
);

export default SuggestionsDivider;
